import { render, staticRenderFns } from "./social-info_pc.vue?vue&type=template&id=7ed56cdc&scoped=true&"
import script from "./social-info_pc.vue?vue&type=script&lang=js&"
export * from "./social-info_pc.vue?vue&type=script&lang=js&"
import style0 from "./social-info_pc.vue?vue&type=style&index=0&id=7ed56cdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed56cdc",
  null
  
)

export default component.exports